import { services as s } from "@/services";
import type { TemplateSettingsSchemaT } from "@/types";
import type { Template } from "@/types/database/diaries";
import { useAuth } from "@/utils/auth";
import { useUpsertTemplate } from "../api/upsertTemplate";
import { useTemplateStore } from "../stores/useTemplateStore";

export const useSubmitTemplate = (templateId?: string) => {
	const { getNewDiaryValues } = useTemplateStore();
	const auth = useAuth();
	const { mutate: upsertTemplate, isPending } = useUpsertTemplate();

	const handleSubmit = () => {
		const storeData = getNewDiaryValues();
		const templateData: Template["Insert"] = {
			template_id: templateId ?? s.uuidv4(),
			user_id: auth?.id,
			template_name: storeData.name,
			template_description: storeData.description,
			settings: {
				...storeData,
				required_events: storeData.required_events,
				role: "PATIENT",
				invited_by: auth?.id,
			} as TemplateSettingsSchemaT,
		};

		upsertTemplate(templateData);
	};

	return {
		handleSubmit,
		isSubmitting: isPending,
	};
};

export default useSubmitTemplate;
